import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {Router} from "@angular/router";
import {SessionStorage} from "ngx-webstorage";
import {Item, Project} from "../../project/shared/project-model";
import {User} from "../user/user";

@Injectable({
  providedIn: 'root'
})

export class ConfigurationEventDatalayerService {
  private window;

  @SessionStorage() currentProject: Project;
  @SessionStorage() currentItemct: Item;
  @SessionStorage() user: User;

  constructor(private windowRef: WindowReferenceService, private router: Router) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(configurationEvent) {
    if (configurationEvent) {
      this.window.dataLayer.push(configurationEvent);
    }
  }

  ConfigurationCompletedEvent() {
    let event = {
      event: 'configuration_complete',
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      configuration_id: (this.currentItemct) ? this.currentItemct.id : '',
      configuration_name: (this.currentItemct) ? this.currentItemct.name : '',
      project_id: this.currentProject?.id,
      project_name: this.currentProject?.name,
      user_id: this.user.id
    }
    this.DataLayerTrigger(event);
  }

  ConfigurationStartedEvent(configuration_id: string, configuration_name: any) {
    let event = {
      event: 'configuration_start',
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      configuration_id: configuration_id,
      configuration_name: configuration_name.slice(2, -3),
      project_id: this.currentProject?.id,
      project_name: this.currentProject?.name,
      user_id: this.user.id
    }
    this.DataLayerTrigger(event);
  }

}
